import { render } from "./employee-details-modal.vue?vue&type=template&id=75535117"
import script from "./employee-details-modal.vue?vue&type=script&lang=js"
export * from "./employee-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__